export const EDITOR = 'ZOTERO_EDITOR';
export const ZOTERO = 'zotero';
export const ZOTERO_SETTINGS = 'ZOTERO_SETTINGS';
export const ZOTERO_COLLECTIONS = 'ZOTERO_COLLECTIONS';
export const ZOTERO_SUB_COLLECTIONS = 'ZOTERO_SUB_COLLECTIONS';
export const ZOTERO_ITEMS = 'ZOTERO_ITEMS';
export const ZOTERO_ITEM_CITATION = 'ZOTERO_ITEM_CITATION';
export const ZOTERO_ITEM_SAVED = 'ZOTERO_ITEM_SAVED';
export const ZOTERO_SEARCH_ITEMS = 'ZOTERO_SEARCH_ITEMS';
export const OPENAIRE_ITEMS_PUB = 'OPENAIRE_ITEMS_PUB';
export const OPENAIRE_ITEMS_RSD = 'OPENAIRE_ITEMS_RSD';
export const REQUEST_ZOTERO = 'REQUEST_ZOTERO';
export const REQUEST_OPENAIRE = 'REQUEST_OPENAIRE';
